module.exports = __webpack_public_path__ + "static/media/hitect.598a740d.jpg";